import Component from "../abstracts/Component";

const CONTACT_US_IDS={
  PERSONAL_STYLIST: "personal_stylist",
    PRODUCT_AND_BOX_DAMAGED: "product_and_box_damaged",
    SOME_PRODUCT_ACCESSORIES_ARE_MISSING: "some_product_accessories_are_missing",
    DAMAGED_OR_FAULTY_PRODUCT: "damaged_or_faulty_product",
    WRONG_PRODUCT: "wrong_product",
    WRONG_COLOUR: "wrong_colour",
    PRODUCT_DESCRIPTION_MISMATCHING: "product_description_mismatching",
    ORDER_ARRIVED_AFTER_SCHEDULED_DATE: "order_arrived_after_scheduled_date",
    CHANGED_MY_MIND: "changed_my_mind",
    DONT_LIKE_COLOUR: "dont_like_colour",
    DOESNT_SUIT: "doesnt_suit",
    TOO_SMALL: "too_small",
    TOO_BIG: "too_big",
    OTHER: "other",
    PRIVACY_AND_DATA_PROTECTION: "privacy_and_data_protection",
    ORDERS_AND_DELIVERIES: "orders_and_deliveries",
    PAYMENTS_AND_PROMOTIONS: "payments_and_promotions",
    COLLABORATIONS: "collaborations",
    COMMENTS_AND_SUGGESTIONS: "comments_and_suggestions",
    PRODUCT_INFO_AND_AVAILABILITY: "product_info_and_availability",
    STORES: "stores",
    REFUND_AND_RETURNS: "refund_and_returns",
    TECHNICAL_ASSISTANCE: "technical_assistance",
    RECEIVED_ITEM_WASNT_THE_ORDERED_ONE: "received_item_wasnt_the_ordered_one",
    DOEST_FIT_ME: "doest_fit_me",
    WRONG_SIZE_OR_COLOUR_ORDERED: "wrong_size_or_colour_ordered",
    IMAGINED_ITEM_DIFFERENT: "imagined_item_different",
    RETAIL_STORES: "retail_stores",
    STOCKS_IN_PHYSICAL_STORES: "stocks_in_physical_stores",
    REPAIRS: "repairs",
    PRODUCT_CARE: "product_care",
    ABOUT_MAX_MARA: "about_max_mara",
}


export default class ContactUsComponent extends Component {
  get SELECTORS() {
    return {
      main: '#contactUsForm',
      subject: '.js-contact-subject',
      returns: '.js-subject-returns',
      orders: '.js-subject-orders',
      blocks: '.js-subject',
      subjectCode: '.js-subject-code',
      contactUs: '.contactUsPageGReCaptchaChallange',
      showFormBtn: '[data-show-form]',
      contactForm: '[data-show]'
    }
  }

  constructor() {
    super()
  }

  submitForm(data, url) {
    return $.ajax({
      url: url,
      method: 'POST',
      data: data,
    });
  }

  showAdditionalData(index) {
    const ordersBlock = document.querySelector(this.SELECTORS.orders);
    const returnsBlock = document.querySelector(this.SELECTORS.returns);
    switch (index) {
      // show order block fields
      case CONTACT_US_IDS.ORDERS_AND_DELIVERIES:
        (returnsBlock ? returnsBlock.classList.add('hidden') : false);
        (ordersBlock ? ordersBlock.classList.remove('hidden') : false);
        break;
      // show return block fields
      case CONTACT_US_IDS.REFUND_AND_RETURNS:
        (ordersBlock ? ordersBlock.classList.add('hidden') : false);
        (returnsBlock ? returnsBlock.classList.remove('hidden') : false);
        break;
      default:
        (ordersBlock ? ordersBlock.classList.add('hidden') : false);
        (returnsBlock ? returnsBlock.classList.add('hidden') : false);
    }
    document.querySelector(this.SELECTORS.subjectCode).value = index;
  }

  bindSubject() {
    this.$on('change', ({event}) => {

      let blocks = $(this.SELECTORS.main).find(this.SELECTORS.blocks);
      this.showAdditionalData(event.currentTarget.selectedOptions[0].id);

      blocks.each(function() {
        let $input = $(this).find('input, select');
        if ($(this).hasClass('hidden')) {
          $input.prop('disabled', true);
        } else {
          $input.prop('disabled', false);
        }
      })

    }, 'body', this.SELECTORS.subject);
  }

  bindShowForm() {
    let showFormBtn = document.querySelector(this.SELECTORS.showFormBtn);
    let contactForm = document.querySelector(this.SELECTORS.contactForm);
    if(showFormBtn) {
      showFormBtn.addEventListener('click', (event) => {
        event.stopPropagation();
        event.preventDefault();
        document.getElementById('contactUsForm').reset();
        contactForm.classList.toggle('hidden');
      });
    }
  }

  bindSubmit() {
    this.$on('submit', ({event}) => {
      event.preventDefault();
      if (window.RecapchaComponent && !window.RecapchaComponent.getResponseFromWidget('contactUsPage')) {
        // User have not completed the challenge
        return;
      }

      if(document.querySelector(this.SELECTORS.subjectCode).value == CONTACT_US_IDS.REFUND_AND_RETURNS ) {
        const datePick = document.querySelector("#datePick");
        if (datePick) {
          datePick.value == '' ? datePick.setAttribute("disabled", "true") : datePick.removeAttribute("disabled")
        }
      }
      var disabled = $('#contactUsForm').find('select:disabled').removeAttr('disabled');
      const form = $(event.target).serialize();
      disabled.attr('disabled','disabled');

      const action = event.currentTarget.getAttribute('action');

      document.querySelector(this.SELECTORS.contactUs).setAttribute('disabled', 'disabled');

      // data.concat(`&${this.getSubjectCode()}`);
      this.submitForm(form, action).then(res => {
        event.currentTarget.parentElement.innerHTML = res;
      });
    }, 'body', this.SELECTORS.main);
  }

  render() {
    this.log('rendering...');
    this.bindSubmit();
    this.bindShowForm();
    if (document.querySelector(this.SELECTORS.returns) || document.querySelector(this.SELECTORS.orders)) {
      this.bindSubject();
      if($(this.SELECTORS.subject)) {
        $(this.SELECTORS.subject).trigger('change');
      }
    }
  }
}
